<template>
  <div id="videoone" >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="two" name="two">
        <Distribution @wrid="isurl" :linkurl="url"></Distribution>
        <DiaGram :src="apk" class="custom-class" @lineDetail="lineDetail" @loopDetail="loopDetail"></DiaGram>
      </el-tab-pane>
      <el-tab-pane :label="therr" name="three">
        <Png :message="message"></Png>
        <HomeVideo
          class="custom-one"
          :videoList="videoList"
          @clickShow="clickshow"
        ></HomeVideo>
      </el-tab-pane>
      <el-tab-pane
        :label="one"
        class="one"
        name="one"
        ><IfromD class="custom-thered"></IfromD
      ></el-tab-pane>
    </el-tabs>
    
      <!-- <LoopDetail :width="width" :height="height" v-if="showLoopDetail" :tab="currentLoopTab"
                :loopUrl="currentLoopUrl" @closeLoopDetail="showLoopDetail = false"
                :currentLoop="loops.filter(item => item.subLoopUrl == currentLoopUrl)" /> -->
  </div>
</template>
<script>
import DiaGram from "../components/Diagram.vue";
import LoopDetail from "../../FirstDiagram/loopDetail"
import Distribution from "./Distribution";
import HomeVideo from "./HomeVideo";
import IfromD from "./ifromD.vue";
import { GetSecurityDevices, GET_AREAS,GET_AREA_LOOPS } from "../../../api/common";
import Png from "./png";
export default {
  name: "videoone",
  data() {
    return {
      one: "3D",
      two: "配电图",
      therr: "监控",
      fullScreen: 0,
      message: "",
      areaId: 1,
      currentVideoIndex: 0,
      videoList: [],
      activeName: "two",
      apk: "",
      url:"",
      loops: [],
      width: 1920,
      height: 870,
      showLoopDetail: false,
      currentLoopTab: '',
      currentLoopUrl:""
    };
  },
  created() {
    GET_AREAS(1).then((res) => {
      this.areaId = res.data.data.areas[0].areaId;
      this.getDevicesData();
      this.getLoops();
    });
  },
  mounted() {
    this.clickshow();
    // this.apk;
  },
  methods: {
    getLoops() {
        GET_AREA_LOOPS(this.areaId).then(res => {
            this.loops = res.data.data.loops
        })
    },
    loopDetail(cmd, loopName) {
      this.$emit('loopDetail',cmd,loopName)
        // this.showLoopDetail = true
        // this.currentLoopUrl = loopName
        // if (cmd == 'SwitchingClosing') {
        //     this.currentLoopTab = '控制'
        // } else if (cmd == 'RealTimeData') {
        //     this.currentLoopTab = '电力数据'
        // }
    },
    lineDetail(val){
      this.url = val;
      this.apk = val;
    },
    //显示影藏
    clickshow(val) {
      this.fullScreen = val;
      // console.log(this.fullScreen, "我是显示隐藏");
      if (this.fullScreen > 0) {
        this.one = "";
        this.two = "";
        this.therr = "";
      } else {
        this.one = "3D";
        this.two = "配电图";
        this.therr = "监控";
      }
    },
    //切换电路
    isurl(val) {
      this.apk = val;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //导航栏
    handleClick(tab, event) {
      // console.log( this.$store.state.homeitem.apk, this.$store.state.homeitem.monitoring)
      console.log(event);
    },
    getDevicesData() {
      GetSecurityDevices(this.areaId).then((res) => {
        let monitorArr = [];
        let id = 0;
        res.data.data.devices.map((item, index) => {
          if (item.device_class_name == "监控设备") {
            monitorArr.push({
              id: id++,
              videoName: item.device_name,
              videoCode: JSON.parse(item.device_details).roomName,
            });
          }
        });
        this.message = monitorArr; //传入PNG的值
        this.$store.commit("massageBug", this.message);
        this.videoList = monitorArr;
        // console.log(this.videoList, "测试");
      });
    },
  },
  components: {
    DiaGram,
    Distribution,
    HomeVideo,
    IfromD,
    Png,
    LoopDetail
  },
};
</script>
<style lang="less" scoped>

#videoone {
  .w(1064);
  .h(640);
  // min-height: 500px;
  background-color: black;
  margin-bottom: 8rem;
  position: relative;
  .monitoringall {
    // display: none;
    z-index: 99;
    position: absolute;
  }

  .el-dropdown-link {
    width: 220rem !important;
    height: 100rem;
    font-size: 18rem;
    // color: #FFFFFF;
  }

  #pane-two {
    height: 100%;
  }
}

#inp {
  .w(248);
  .h(32);
  background: #ffffff;
  border: 1rem solid #000000;
  opacity: 0.15;
  border-radius: 16rem;
  margin-bottom: 16rem;
  margin-left: 16rem;
  //   margin-top: 16rem;
  padding: 5rem 18rem 4rem 15rem;
  display: flex;
  justify-content: space-between;
  #sousuo {
    .w(18);
    .h(18);
    background-color: black;
  }
  #div-inp {
    width: 248rem;
    height: 15rem;
    font-size: 16rem;
    margin-top: 0;
  }
}
</style>
